import type { User } from "@eai-toolkit/client";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import { actions as apiActions } from "../api/actions";

export type UserState = {
  user?: User;
};

const INITIAL_STATE: UserState = {};

export function user(
  state: UserState = INITIAL_STATE,
  action: ActionType<typeof apiActions>,
): UserState {
  switch (action.type) {
    case getType(apiActions.getMe.success): {
      return {
        ...state,
        user: action.payload,
      };
    }
    default:
      return state;
  }
}
